import './styles/style.min.css';

import Header from './components/header';
import Nav from './components/nav';
import About from './components/about';
import Portfolio from './components/portfolio';
import Formations from './components/formation';
import Experiences from './components/experience';
import ContactForm from './components/contact';
import Footer from './components/footer';

import Helmet from 'react-helmet';

function App() {
  return (
    <div className="App">
      <Helmet>
      <meta charSet="utf-8" />
      <title>Paolo Trapu - Développeur Front</title>
      <link rel="canonical" href="https://paolotrapu.netlify.app/" />
      <meta name="Paolo Trapu" content="Paolo Trapu" />
      <meta name="description" content="Développeur Front, réalisation de projets Front avec React, Wordpress et PHP.
      En formation pour passer le tire de Concepteur Développeur d'application"></meta>
      </Helmet>


      <Nav />
      <Header />
      <About />
      <Portfolio />
      <Formations />
      <Experiences/>
      <ContactForm  />
      <Footer/>
    </div>
  );
}

export default App;
